import ClosureEditor from './ClosureEditor.vue';

export default ClosureEditor;
